import * as React from 'react';

import { Box, Grid, Link, MenuItem, Step, StepLabel, Stepper, TextField } from '@mui/material';
import { usePallet } from '../../../contexts/PalletContext';
import { isMobile } from 'react-device-detect';
import { useEffect, useState } from 'react';
import { Divider } from '@mui/material';
import { useAlert } from "../../../contexts/AlertContext";
import styled from 'styled-components';

import { BootstrapDialog, BootstrapDialogTitle } from '../../../components/BootstrapDialogTitle';


import { useAuthorization } from '../../../contexts/AuthorizationContext';
import DiarioService from '../../../services/DiarioService';

export default function CitacaoModal(props: { id: number,mensagem: any}) {
    const { pallet } = usePallet();
    const [open, setOpen] = React.useState(false);
    const [texto, setTexto] = React.useState("");

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const NotificacaoNotContent = styled(Grid)`
      padding: 14px;
      a {
        text-decoration: none;
        color: #4B1196;
      }
      span { color: #4B1196; font-weight: 600; }
      b { color: #1E0736 }
      ul {
        padding-left: 0px;
        li {
          color: #1E0736;
          font-weight: 400;
          word-break: break-word;
          list-style-type: '';
          ::before{ content: '»'; }
          ul {
            li { ::before{ content: '⋙'; } padding-left: 1em; }
          }
        }
      }
    `;

    console.log("ASUAIUSIAUSIUA",props.mensagem)

    useEffect(() => {
        // getItem();

        if(open) {
            DiarioService.GetTextoDiario(String(props.id)).then(async (res) => {
                setTexto(res?.data[0]?._source?.texto);
              });
    
        }
        

    }, [open])

    const { user } = useAuthorization();



    const { NewAlert } = useAlert();
    const permissaoErro = () => {
  
        NewAlert("error","Não é possível realizar está ação com este perfil.")
        }



    return (
        <div>
            <Link href="#" onClick={handleClickOpen} underline="none"
                style={{
                    fontWeight: pallet.fontWeight.subtitle,
                    fontSize: `${pallet.general.size14}`,
                    color: `${pallet.color.secundary.font}`
                }}>
                {'Ver todos os trechos citados'}
            </Link>

            <BootstrapDialog style={{ paddingLeft: `${isMobile ? "0px" : "15px"}` }}
                maxWidth={"lg"}
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}                
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    DIÁRIO
                </BootstrapDialogTitle>

        



                <Divider style={{ marginBottom: "15px" }} />


                <NotificacaoNotContent
                dangerouslySetInnerHTML={{
                    __html: props.mensagem ? props.mensagem :
                        "<span>PLP230/2020 • <b>Apensada a</b> PL2267/2019</span>\n" +
                        "<b>Câmara dos Deputados</b>\n" +
                        "<ul>\n" +
                        "<li>\n" +
                        "<b> Ementa:</b> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.\n" +
                        "</li>\n" +
                        "</ul>",
                }}
                />

                {/* <Grid style={{
                    fontFamily: `${pallet.general.fontFamily}`,
                    fontSize: `${pallet.general.size16}`,
                    fontWeight: pallet.general.weight_300,
                    alignItems: "center",
                    lineHeight: "1.6",
                    color: "#1E0736",
                    height: "100%",
                    textAlign: "justify",
                    width: "100%",
                    overflow: "scroll",
                    overflowX: "hidden",
                    padding: `${isMobile ? "10px 15px 10px 15px" : "20px 20px 20px 30px"}`
                }}>
                    {texto}
                </Grid> */}

            </BootstrapDialog>
        </div >
    );
}
